export default __webpack_public_path__ + "static/media/coffe2.e9d1ce7b.png";